import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=17dca741&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\invoiceasy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17dca741')) {
      api.createRecord('17dca741', component.options)
    } else {
      api.reload('17dca741', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=17dca741&", function () {
      api.rerender('17dca741', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/Index.vue"
export default component.exports